import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { CaptionService } from '../../../../utils/shared-services/caption.service';

@Component({
    selector: 'backup-deleteOne-dialog',
    templateUrl: 'src/app/features/stores/templates/dialogs/backup-deleteOne-dialog.html',
    standalone: false
})
export class BackupDeleteOneDialog {

    public captions: Record<string, string>;

    constructor(
        @Inject(MatDialogRef) public dialogRef: MatDialogRef<BackupDeleteOneDialog>,
        @Inject(CaptionService) private captionService: CaptionService,
    ) {
        this.captions = this.captionService.captions;
    }
}
